import { useEffect, useRef, useState } from 'react';
export var useUnidirectionalScroll = scrollerRef => {
  var startPos = useRef([0, 0]);
  // null means no scroll
  var [isHorizontalScroll, setIsHorizontalScroll] = useState(null);

  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(() => {
    var _CSS;
    var scrollingElement = scrollerRef === null || scrollerRef === void 0 ? void 0 : scrollerRef.current;
    var isSafariIOS = ((_CSS = CSS) === null || _CSS === void 0 ? void 0 : _CSS.supports) && CSS.supports('-webkit-touch-callout', 'none');
    var onTouchStart = e => {
      startPos.current = [e.touches[0].screenX, e.touches[0].screenY];
    };
    var onTouchMove = e => {
      if (isHorizontalScroll || isHorizontalScroll === null && (isHorizontalScroll !== null || !isSafariIOS)) {
        e.preventDefault();
      }
      if (isHorizontalScroll === null) {
        var lowerBoundAngle = 60;
        var upperBoundAngle = 120;
        var dx = e.touches[0].screenX - startPos.current[0];
        var dy = -(e.touches[0].screenY - startPos.current[1]);
        startPos.current = [e.touches[0].screenX, e.touches[0].screenY];
        var angle = Math.atan2(dy, dx) * 180 / Math.PI;
        setIsHorizontalScroll(angle <= -upperBoundAngle || angle >= upperBoundAngle || angle >= -lowerBoundAngle && angle <= lowerBoundAngle);
        if (isSafariIOS && (angle <= -upperBoundAngle || angle >= upperBoundAngle || angle >= -lowerBoundAngle && angle <= lowerBoundAngle)) {
          e.preventDefault();
        }
      }
    };
    var onTouchEnd = () => {
      setIsHorizontalScroll(null);
    };
    if (!!scrollingElement) {
      scrollingElement.addEventListener('touchstart', onTouchStart);
      scrollingElement.addEventListener('touchmove', onTouchMove);
      scrollingElement.addEventListener('touchend', onTouchEnd);
      return () => {
        scrollingElement.removeEventListener('touchstart', onTouchStart);
        scrollingElement.removeEventListener('touchmove', onTouchMove);
        scrollingElement.removeEventListener('touchend', onTouchEnd);
      };
    }
  }, [isHorizontalScroll, scrollerRef]);
  return {
    isHorizontalScroll
  };
};